import { render, staticRenderFns } from "./escaperoom.vue?vue&type=template&id=0382677d&scoped=true&"
import script from "./escaperoom.vue?vue&type=script&lang=js&"
export * from "./escaperoom.vue?vue&type=script&lang=js&"
import style0 from "./escaperoom.vue?vue&type=style&index=0&id=0382677d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0382677d",
  null
  
)

export default component.exports